/**
 * It will return the basket size and lead time if orientation specific values are available.
 * If not, it will return undefined.
 */

import { useSkillsAssessments } from "@src/appV2/SkillsAssessment/api/useSkillsAssessments";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function useOrientationBasketSizeExperimentLimits():
  | {
      status: "loading" | "error";
    }
  | {
      status: "success";
      data:
        | {
            basketSize: number | undefined;
            leadTimeInHours: number | undefined;
            onTimeClipboardScoreAdjustment: number | undefined;
          }
        | undefined;
    } {
  const worker = useDefinedWorker();
  const { data: orientation, status } = useSkillsAssessments({
    workerId: worker.userId,
  });

  if (status === "loading" || status === "error") {
    return {
      status,
    };
  }

  const loadedExperimentData = orientation?.data[0]?.attributes.experimentDetails;
  if (loadedExperimentData?.experimentType === "LimitShiftsAccessBasedOnOrientationTimeliness") {
    return {
      status: "success",
      data: {
        basketSize: loadedExperimentData?.experimentMetadata?.basketSize,
        leadTimeInHours: loadedExperimentData?.experimentMetadata?.leadTimeInHours,
        onTimeClipboardScoreAdjustment:
          loadedExperimentData?.experimentMetadata?.onTimeClipboardScoreAdjustment,
      },
    };
  }

  return {
    status,
    data: undefined,
  };
}
